import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { Button } from '@design-system/components/button/button';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
}: ConfirmationModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Exit screen?"
      disableBackdropClick={true}
      modalClassName="w-full md:w-[450px]"
    >
      <div className="flex flex-col gap-6">
        <Typography variant="bodyLarge">
          Are you sure you want to exit the upload screen? Any progress will be
          lost.
        </Typography>
        <div className="flex justify-between">
          <Button onClick={onClose} color="neutral">
            Cancel
          </Button>
          <Button onClick={onConfirm} variant="text" color="neutral">
            Exit
          </Button>
        </div>
      </div>
    </Modal>
  );
};
